export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8649.ee248e46.jpg";